<template>
  <section class="snap-section hero">
    <h1 class="headline">
      Сверхбыстрый и надежный <span class="highlight">VPS сервер</span> прямо в вашем приложении
    </h1>
  </section>
</template>

<style scoped>
.hero {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  min-height: calc(100vh - var(--header-h) - var(--footer-h));
}

.headline {
  font-family: 'Bungee', 'Play', sans-serif;
  font-size: 38px;
  line-height: 1.2;
  max-width: 350px;
  letter-spacing: 0.5px;
  color: #333;
  text-shadow: -1px -1px 0 #fff, 1px -1px 0 #fff,
               -1px 1px 0 #fff, 1px 1px 0 #fff;
  filter: drop-shadow(0 0 4px rgba(255, 255, 255, 0.8));
}

.highlight {
  color: #6197bb;
}
</style>
